import React from 'react';
import classNames from 'classnames';
import './ButtonSet.scss';

const ButtonSet = ({ disabled, onChange, options, value }) => {
  return (
    <div className="ButtonSet">
      {options.map(option => (
        <div
          className={classNames(`ButtonSet-option ${option.className}`, {
            'ButtonSet-button-selected': option.value === value,
            'ButtonSet-button-unselected': option.value !== value,
          })}
          key={option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

export default ButtonSet;
